import React, {Component} from 'react';
import { connect } from 'react-redux';
import $ from 'jquery';
import _ from 'lodash';

import {GaleriaBig} from './Galeria.jsx';
import {SelectProducto} from './SelectProducto.jsx';
import {GaleriaIcons} from './Galeria.jsx';
import {doAjax} from '../helpers.js';

class PedidoP extends Component {
  render() {
    const Resumen = this.props.resumen;
    const Extras = this.props.extras;

    return(
      <div className="container">
        <div className="row">
          <div className={Resumen ? "col-md-8 col-lg-9" : "col-md-12" }>
            <this.props.galeria/>
            { Extras && <div><hr/><Extras pedido={this.props.pedido} /></div> }
          </div>
          {Resumen ?
          <div className="col-md-4 col-lg-3" ref="lateral_der">
            <div className="detalles_carrito">
              <Resumen pedido={this.props.pedido}/>
            </div>
          </div>
          : null
          }
        </div>
      </div>
      );
    }
  };

class PedidoResumenP extends Component {
    state = {
      producto_id: Config.temporadas[Config.temporada].productos[0].id,
      }
    render() {
    var formas_de_pago = Config.formas_de_pago;
    var subtotal = _.sum(_.map(this.props.pedido.fotos, f => Number(f.precio)));
    var descuento = this.props.pedido.descuento;

    return (
          <div>
            <h4>Generales</h4>
            <div><SelectProducto temporada={Config.temporada} value={this.state.producto_id} onSelect={p => this.setState({producto_id: p})}/></div>
            <div><button className="btn btn-default btn-login" onClick={() => this.props.cambio_general_producto(this.state.producto_id)}>Aplicar</button></div>
            <h4>Mi compra</h4>
            { descuento > 0 ?
            <h5>Subtotal: {subtotal} {Config.moneda}</h5> : null }
            { descuento > 0 ?
            <h5>Descuento: {descuento} {Config.moneda}</h5> : null }
            <h5>Total: {subtotal - descuento} {Config.moneda}</h5>
            { formas_de_pago.length > 1 ? <h4>Comprar con</h4> : null}
            { _.map(formas_de_pago, (f,id) => 
               <button className="btn btn-default btn-login" onClick={() => this.props.comprar(id)} key={id}>{f.logo ? <img src={"images/formasdepago/"+f.logo}/> : f.nombre}</button>
            )}
          </div>
          );
    }
  }

function PedidoIcons(props) {
  const f = props.foto;
  return (
      <div className="icons">
        <div className="producto"><SelectProducto temporada={f.t} onSelect={p => {props.set_active();props.select_producto(f, p)}} value={f.producto}/></div>
        <div>
          <div className="cantidad" style={{fontSize: "200%"}}>
            <a className={"fa fa-2x "+ (f.cantidad>1 ? "fa-arrow-circle-down" : "fa-times-circle")} onClick={() => {props.set_active();props.bajar(f)}}/>
            <span className="valor">{f.cantidad}</span>
            <a className="fa fa-2x fa-arrow-circle-up" onClick={() => {props.set_active();props.subir(f)}}/>
          </div>
          <div className="precio">
            <span className="valor">
              {Number(props.foto.precio)}
              &nbsp;
              {Config.moneda}
            </span>
          </div>
        </div>
      </div>
      );
  }

export const PedidoAbiertoIcons = (pedido_id, pref="") => connect(st => ({}),
                                 d => ({
                                        subir: (f) => d(doAjax(pref+"/pedido/set_cantidad?"+$.param({pedido_id: pedido_id, foto_id: f.i, cantidad: f.cantidad+1}),"POST")),
                                        bajar: (f) => d(doAjax(pref+"/pedido/set_cantidad?"+$.param({pedido_id: pedido_id, foto_id: f.i, cantidad: f.cantidad-1}),"POST")),
                                        select_producto: (f,p) => d(doAjax(pref+"/pedido/select_producto?"+$.param({producto_id: p, pedido_id: pedido_id, foto_id: f.i, }),"POST")),
                                       })
                                 )(PedidoIcons);

function PedidoResumen(props) {
  const pedido = props.pedido;
  const R = connect(st => ({pedido: pedido}),
                    d => ({cambio_general_producto: (p) => {d(doAjax("/pedido/set_producto?"+$.param({pedido_id: pedido.id, producto_id: p}),"POST"))},
                           comprar: (fp) => {d(doAjax("/comprar/"+fp+"?"+$.param({pedido_id: pedido.id}),"POST"));},
                         }))
                    (PedidoResumenP);
  return <R/>;
  }

export function Pedido_(pedido, icons, resumen, extras) {
  const P = (props_) => GaleriaBig({fotos: pedido.fotos.filter(f => f.cantidad>0), galeria: pedido.id, icons: icons},
                                   (props_) => <PedidoP pedido={pedido} resumen={resumen} extras={extras} {...props_}/>);
  return <P/>;
  }

export function Pedido(props) {
  const pedido = props.pedido;
  return Pedido_(pedido, pedido.pagado ? GaleriaIcons : PedidoAbiertoIcons(pedido.id), pedido.pagado ? null : PedidoResumen);
  }
